import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, sortBy, uniqBy } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import TitleFrom from '../../../../components/common/TitleFrom';
import {
  uploadMultiPartFiles,
  saveOutputTemplateByType,
  getOutputTemplateByType,
  getFlexAttributesMappingConfig,
} from '../../../App/actions';
import { ProvisioningDataSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportProvisioningData, sortProvisioningData } from '../../constants';
import { getProvisioningDataReport, getAllProvisioningDataReport } from '../../actions';
import { makeGetListProvisioningData, makeGetListAllProvisioningData } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class ProvisioningData extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listProvisioningData: [],
    emails: [],
    optionsSelectAttr: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listProvisioningData: props.listProvisioningData,
      totalCount: getPageTotalCount({ ...state, items: props.listProvisioningData }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetProvisioningData },
    } = this.props;
    if (modeGetProvisioningData) {
      this.doGetListProvisioningData();
      this.doGetOutputTemplateByType();
      this.doGetFlexAttributesMappingConfig();
    }
  }

  doGetFlexAttributesMappingConfig = () => {
    const { optionsSelectAttr } = this.state;
    const { getFlexAttributesMappingConfig } = this.props;
    if (!optionsSelectAttr || !optionsSelectAttr.length)
      getFlexAttributesMappingConfig({ objectType: 'SERVICE' }, ({ success, data }) => {
        if (success) {
          const optionsList =
            data && data.types && data.types.length
              ? data.types.map(val => ({ value: val.provAttributeType, label: val.provAttributeType }))
              : [];

          this.setState({ optionsSelectAttr: optionsList ? uniqBy(sortBy(optionsList, ['label']), 'label') : [] });
        }
      });
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListProvisioningData();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListProvisioningData());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListProvisioningData());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListProvisioningData();
    });
  };

  doGetListProvisioningData = () => {
    const { filter, page, size, sorted } = this.state;
    const { getProvisioningDataReport } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortProvisioningData[sorted.sortCol]
          ? sortProvisioningData[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getProvisioningDataReport(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistProvisioningData = cb => {
    const { filter, sorted } = this.state;
    const { getAllProvisioningDataReport } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortProvisioningData[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllProvisioningDataReport(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistProvisioningData(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllProvisioningData, t } = this.props;
        convertJson2Pdf({
          data: listAllProvisioningData,
          t,
          title: t('reportPage:sidebar.provisioningData').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.provisioningData')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistProvisioningData(() => {
      const { listAllProvisioningData, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_PROVISIONING_DATA_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.provisioningData')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.provisioningData')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllProvisioningData,
            t,
            columns: tableColumnsOutput,
            listOptionFields: {
              ServiceType: 'serviceType',
              type: 'typeProvisioning',
            },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllProvisioningData,
          t,
          title: t('reportPage:sidebar.provisioningData').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.provisioningData')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.provisioningData')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('PROVISIONING_DATA_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportProvisioningData,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listProvisioningData,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
      optionsSelectAttr,
    } = this.state;
    const {
      listAllProvisioningData,
      t,
      permissions: { modeGetProvisioningData, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetProvisioningData) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.provisioningData') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.provisioningData')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <ProvisioningDataSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  isMultipleOptionInject
                  optionsInject={{
                    type: optionsSelectAttr,
                  }}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.provisioningData').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllProvisioningData,
                          t,
                          title: t('reportPage:sidebar.provisioningData').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.provisioningData')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listProvisioningData}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listProvisioningData && listProvisioningData.length ? listProvisioningData : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

ProvisioningData.propTypes = {
  getProvisioningDataReport: PropTypes.func,
  getAllProvisioningDataReport: PropTypes.func,
  listAllProvisioningData: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

ProvisioningData.defaultProps = {
  getProvisioningDataReport: () => {},
  getAllProvisioningDataReport: () => {},
  listAllProvisioningData: [],
};

const mapStateToProps = createStructuredSelector({
  listProvisioningData: makeGetListProvisioningData() || [],
  listAllProvisioningData: makeGetListAllProvisioningData() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getProvisioningDataReport,
    getAllProvisioningDataReport,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    getFlexAttributesMappingConfig,
  })(ProvisioningData)
);
